import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import i18n from 'i18next';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { useSelector, useDispatch } from 'react-redux';
import { setFilterItems, setInformationArea } from '../../redux/traffic-live';
import DropDown from '../ui/react-ui/dropdown';
var t = i18n.getFixedT(null, 'traffic-live');
var InformationFilter = /*#__PURE__*/React.memo(function (props) {
  // redux data, dispatch
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$trafficL = _useSelector.trafficLive,
      filterItems = _useSelector$trafficL.filterItems,
      informationArea = _useSelector$trafficL.informationArea,
      _useSelector$app = _useSelector.app,
      zonesListData = _useSelector$app.zonesListData,
      zonesList = _useSelector$app.zonesList;

  var dispatch = useDispatch();
  var markerTypes = props.markerTypes;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownList = _useState2[0],
      setDropdownList = _useState2[1];

  var handleClearAll = function handleClearAll() {
    return dispatch(setFilterItems([]));
  };

  var handleSelectAll = function handleSelectAll() {
    return dispatch(setFilterItems(['camera', 'roads-event', 'live-traffic', 'terminal-station', 'gate-station']));
  };

  var handleSelectFilter = function handleSelectFilter(item) {
    if (filterItems.indexOf(item) >= 0) {
      var newFilterItems = _.cloneDeep(filterItems);

      _.remove(newFilterItems, function (el) {
        return el === item;
      });

      return dispatch(setFilterItems(newFilterItems));
    }

    return dispatch(setFilterItems([].concat(_toConsumableArray(filterItems), [item])));
  };

  var handleAreaChange = function handleAreaChange(val) {
    var areaData = _.find(zonesListData, function (el) {
      return el.id === val;
    });

    dispatch(setInformationArea(areaData));
  };

  var renderInstructions = function renderInstructions() {
    var items = [['car', t('lbl-car-detectors')], ['gate', t('lbl-gates')], ['terminal', t('lbl-terminals')], ['camera', t('lbl-cctv')], ['alert', t('lbl-traffic-events')]];
    var statusAry = new Array(3);
    return _.map(items, function (el) {
      var iconDom = /*#__PURE__*/React.createElement("img", {
        className: "icon",
        src: "".concat(contextRoot, "/images/icon/icon-").concat(el[0], "-select.png")
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-span"
      }, el[1]), el[0] === 'camera' || el[0] === 'alert' ? /*#__PURE__*/React.createElement("div", {
        className: "icon-status"
      }, iconDom) : _.map(statusAry, function (el, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "status"
        }, /*#__PURE__*/React.createElement("div", {
          className: cx('icon-status', "level".concat(index + 1))
        }, iconDom), /*#__PURE__*/React.createElement("span", {
          className: "status-instruction"
        }, t("lbl-level".concat(index + 1))));
      }));
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "information-filter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('lbl-select-area')), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-select'),
    list: zonesList,
    value: informationArea ? informationArea.id : '',
    onChange: handleAreaChange,
    width: "300px"
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-flex fdr fww jcsb filter-buttton-block"
  }, _.map(markerTypes, function (item) {
    var isSelected = filterItems.indexOf(item.dataType) >= 0;
    return /*#__PURE__*/React.createElement("button", {
      key: item.dataType,
      className: cx('button', {
        'selected': isSelected
      }),
      onClick: function onClick() {
        return handleSelectFilter(item.dataType);
      }
    }, /*#__PURE__*/React.createElement("img", {
      className: "icon",
      src: "".concat(contextRoot, "/images/icon/icon-").concat(item.icon).concat(isSelected ? '-select' : '', ".png")
    }), /*#__PURE__*/React.createElement("span", null, item.label));
  })), /*#__PURE__*/React.createElement("div", {
    className: "instruction-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "guide"
  }, /*#__PURE__*/React.createElement(HelpOutlineIcon, {
    className: "guide-icon"
  }), /*#__PURE__*/React.createElement("span", null, t('lbl-icons-instruction'))), /*#__PURE__*/React.createElement("div", {
    className: "items"
  }, renderInstructions())), /*#__PURE__*/React.createElement("div", {
    className: "c-flex fdr fww jcsb action"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button clear",
    onClick: handleClearAll
  }, t('lbl-clear')), /*#__PURE__*/React.createElement("button", {
    className: "button selectedAll",
    onClick: handleSelectAll
  }, t('lbl-select-all'))));
});
export default InformationFilter;